import React from "react";
import { Link, useLocation } from "react-router-dom";

const ServiceArea = [
  {
    label: "Karadeniz Mahallesi Halı Yıkama",
    path: "/gaziosmanpasa/karadeniz-hali-yikama",
    description:
      "Karadeniz Mahallesi’nde halılarınızı antibakteriyel ürünlerle temizliyor, kapıdan alım ve teslimat sağlıyoruz."
  },
  {
    label: "Yenidoğan Mahallesi Halı Yıkama",
    path: "/gaziosmanpasa/yenidogan-hali-yikama",
    description:
      "Yenidoğan Mahallesi’nde halılarınız tam otomatik makinelerde hijyenik şekilde yıkanır, aynı gün teslim edilir."
  },
  {
    label: "Kazım Karabekir Mahallesi Halı Yıkama",
    path: "/gaziosmanpasa/kazim-karabekir-hali-yikama",
    description:
      "Kazım Karabekir Mahallesi’nde çevre dostu ürünlerle sağlıklı ve özenli halı yıkama hizmeti sunuyoruz."
  },
  {
    label: "Merkez Mahallesi Halı Yıkama",
    path: "/gaziosmanpasa/merkez-hali-yikama",
    description:
      "Gaziosmanpaşa Merkez Mahallesi’nde halılarınızı özenle temizliyor, hızlı teslimat sağlıyoruz."
  },
  {
    label: "Mevlana Mahallesi Halı Yıkama",
    path: "/gaziosmanpasa/mevlana-hali-yikama",
    description:
      "Mevlana Mahallesi’nde bireysel ve kurumsal halı yıkama ihtiyaçlarınıza özel hizmet veriyoruz."
  },
  {
    label: "Bağlarbaşı Mahallesi Halı Yıkama",
    path: "/gaziosmanpasa/baglarbasi-hali-yikama",
    description:
      "Bağlarbaşı Mahallesi’nde halılarınız modern sistemlerle el değmeden yıkanır, steril şekilde paketlenir."
  },
  {
    label: "Fevzi Çakmak Mahallesi Halı Yıkama",
    path: "/gaziosmanpasa/fevzi-cakmak-hali-yikama",
    description:
      "Fevzi Çakmak Mahallesi’nde hijyen garantili halı temizliği, kapıdan alım ve teslimat dahil sunulur."
  }
];

const GaziosmanpasaSidebar = () => {
  const location = useLocation();

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">GAZİOSMANPAŞA SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
        {ServiceArea.map((area, index) => (
          <div key={index}>
            <Link
              to={area.path}
              className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-red-600 text-white"
                  : "text-red-900 hover:bg-green-100 hover:text-red-800"
              }`}
            >
              {area.label}
            </Link>
            <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GaziosmanpasaSidebar;
